<template>
  <el-dialog
    class="competition-of-drill-type-remove-dialog-dialog"
    :visible.sync="show"
    title="比赛视频下榜处理"
    top="0"
    center
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rule" inline>
      <el-form-item label="下榜原因" prop="reason">
        <el-select v-model="form.reason">
          <el-option v-for="(option, index) in reasonOptions" :key="index" :label="option" :value="option"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="tip">被下榜的参赛选手，其比赛成绩将被取消</div>
    <div class="operation-box">
      <el-button type="info" plain @click="handleCancel"> 取消 </el-button>
      <el-button type="primary" @click="handleSubmit"> 确认 </el-button>
    </div>
  </el-dialog>
</template>

<script lang="ts">
import { BaseComponent, Component, PropSync, Emit } from 'kuaidong-component'

@Component({
  components: {},
})
export default class CompetitionOfDrillTypeRemoveDialog extends BaseComponent {
  @PropSync('visible', { type: Boolean })
  show!: boolean

  rule = {
    reason: {
      type: String,
      required: true,
      trigger: blur,
    },
  }
  reasonOptions = ['假跳等比赛作弊情况', '与比赛项目无关的视频', '其他需要下榜的情况']
  form = {
    reason: '假跳等比赛作弊情况',
  }
  CompetitionOfDrillTypeRemoveDialogVisible = false

  @Emit('submit')
  handleSubmit() {
    return this.form.reason
  }

  @Emit('cancel')
  handleCancel() {
    return
  }
}
</script>

<style lang="less">
@import '../assets/style/dialog.less';

.el-dialog__wrapper.competition-of-drill-type-remove-dialog-dialog {
  .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    width: 544px;
    max-width: 80%;
    border-radius: 8px;

    > .el-dialog__body {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 30px;
    }
  }

  .el-select {
    width: 352px;
  }
  .tip {
    color: #9da2a9;
    margin: 0 0 0 -20px;
  }

  .operation-box {
    margin-top: 40px;
    margin-left: 0px;
    .el-button {
      padding: 9px 54px;
    }
  }
}
</style>
